/**
 * Utilidades para el recorrido de bienvenida (onboarding) del menú principal.
 *
 * Se recuerda en el navegador del usuario, igual que el aviso de novedades.
 */

const STORAGE_KEY = "fyp:onboarding-seen:v1";

export const wasOnboardingSeen = (): boolean => {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
};

export const markOnboardingSeen = (): void => {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, "true");
  } catch {
    /* ignore quota errors */
  }
};

export const clearOnboardingSeen = (): void => {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
};
